import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import "./DailyPurchases.css";

const DEFAULT_CATEGORIES = [
  {
    name: "Fournitures de bureau",
    icon: "📁",
    subCategories: [
      { name: "Agrafe 24/6", unit: "boîte", estimatedPrice: 2.5 },
      { name: "Agrafeuse de bureau", unit: "pièce", estimatedPrice: 15.0 },
      { name: "Stylo à bille (Bleu/Noir)", unit: "paquet", estimatedPrice: 4.5 },
      { name: "Rouleau de caisse thermique 80mm", unit: "rouleau", estimatedPrice: 1.8 },
      { name: "Papier A4 (Ramette 500f)", unit: "ramette", estimatedPrice: 14.5 },
      { name: "Post-it & Blocs-notes", unit: "paquet", estimatedPrice: 3.2 },
      { name: "Surligneurs fluorescents", unit: "pack", estimatedPrice: 5.0 },
      { name: "Ruban adhésif (Scotch)", unit: "pièce", estimatedPrice: 3.5 },
      { name: "Correcteur ruban/liquide", unit: "pièce", estimatedPrice: 2.2 }
    ]
  },
  {
    name: "Produits d'entretien & Hygiène",
    icon: "🧹",
    subCategories: [
      { name: "Désinfectant multi-surfaces", unit: "litre", estimatedPrice: 6.5 },
      { name: "Javel désinfectante 5L", unit: "bidon", estimatedPrice: 8.0 },
      { name: "Lave-sol parfumé 5L", unit: "bidon", estimatedPrice: 12.0 },
      { name: "Papier essuie-tout professionnel", unit: "rouleau", estimatedPrice: 7.5 },
      { name: "Papier hygiénique (Pack 24)", unit: "pack", estimatedPrice: 18.0 },
      { name: "Savon liquide mains 5L", unit: "bidon", estimatedPrice: 14.0 },
      { name: "Sacs poubelle renforcés 100L", unit: "rouleau", estimatedPrice: 6.0 },
      { name: "Éponges & Lavettes microfibres", unit: "pack", estimatedPrice: 4.5 },
      { name: "Gants de ménage", unit: "paire", estimatedPrice: 2.5 }
    ]
  },
  {
    name: "Consommables & Emballages",
    icon: "📦",
    subCategories: [
      { name: "Sacs kraft boutique", unit: "lot 100", estimatedPrice: 22.0 },
      { name: "Étiquettes code-barres thermiques", unit: "rouleau", estimatedPrice: 11.0 },
      { name: "Film étirable d'emballage", unit: "rouleau", estimatedPrice: 16.5 },
      { name: "Ruban adhésif d'emballage 'Fragile'", unit: "rouleau", estimatedPrice: 4.0 }
    ]
  },
  {
    name: "Petit outillage & Maintenance",
    icon: "🔧",
    subCategories: [
      { name: "Piles AA (Pack de 4)", unit: "pack", estimatedPrice: 6.0 },
      { name: "Piles AAA (Pack de 4)", unit: "pack", estimatedPrice: 6.0 },
      { name: "Ampoules LED E27", unit: "pièce", estimatedPrice: 5.5 },
      { name: "Rallonge multiprise 5m", unit: "pièce", estimatedPrice: 18.0 },
      { name: "Câble réseau RJ45 3m", unit: "pièce", estimatedPrice: 6.5 }
    ]
  },
  {
    name: "Cafétéria & Accueil Clients",
    icon: "☕",
    subCategories: [
      { name: "Café en grains/moulu 1kg", unit: "kg", estimatedPrice: 28.0 },
      { name: "Capsules de café expresso", unit: "boîte 50", estimatedPrice: 45.0 },
      { name: "Gobelets en carton", unit: "lot 100", estimatedPrice: 7.0 },
      { name: "Sucre en bûchettes", unit: "boîte 200", estimatedPrice: 9.0 },
      { name: "Touillettes en bois", unit: "paquet 500", estimatedPrice: 4.0 },
      { name: "Bouteilles d'eau minérale 1.5L", unit: "pack de 6", estimatedPrice: 4.8 }
    ]
  }
];

const STANDARD_UNITS = [
  "pièce",
  "kg",
  "litre",
  "boîte",
  "paquet",
  "lot",
  "rouleau",
  "ramette",
  "bidon",
  "pack",
  "mètre",
  "paire",
  "boîte 50",
  "lot 100",
  "carton",
  "autre"
];

const ControleValidationAchats = () => {
  const currentUser = useSelector((state) => state.AuthReducer?.user);

  const [requests, setRequests] = useState([]);
  const [locations, setLocations] = useState([]);
  const [categoriesList, setCategoriesList] = useState(DEFAULT_CATEGORIES);
  const [loading, setLoading] = useState(true);

  // Filtres
  const [selectedStatus, setSelectedStatus] = useState("en_attente");
  const [selectedLocation, setSelectedLocation] = useState("all");
  const [search, setSearch] = useState("");

  // Modale de traitement par le contrôleur
  const [activeRequest, setActiveRequest] = useState(null);
  const [editedItems, setEditedItems] = useState([]);
  const [controllerNotes, setControllerNotes] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [supplierGlobalName, setSupplierGlobalName] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("Espece");
  const [validating, setValidating] = useState(false);
  const [suppliersList, setSuppliersList] = useState([]);

  // Section d'ajout d'article par le contrôleur
  const [showAddArticleForm, setShowAddArticleForm] = useState(false);
  const [selectedPresetCat, setSelectedPresetCat] = useState("");
  const [newArticleForm, setNewArticleForm] = useState({
    categoryName: "Fournitures de bureau",
    subCategoryName: "",
    articleName: "",
    unit: "pièce",
    requestedQuantity: 1,
    purchasedQuantity: 1,
    actualUnitPrice: 0,
    actualTotalPrice: 0,
    supplierName: "",
    notes: ""
  });

  // Modale d'ajout direct d'un nouveau fournisseur & contrôle anti-doublon
  const [showAddSupplierModal, setShowAddSupplierModal] = useState(false);
  const [addingSupplierTarget, setAddingSupplierTarget] = useState("global"); // "global", "article-new", ou index d'article
  const [newSupplierForm, setNewSupplierForm] = useState({
    companyName: "",
    phone: "",
    address: "",
    MatriculeF: "",
    category: "Achats Quotidiens",
    notes: ""
  });
  const [savingSupplier, setSavingSupplier] = useState(false);
  const [supplierNotification, setSupplierNotification] = useState(null);

  // Vérification instantanée si un fournisseur existe déjà (insensible à la casse)
  const findExistingSupplier = (name) => {
    if (!name || typeof name !== "string") return null;
    const clean = name.trim().toLowerCase();
    if (!clean) return null;
    return suppliersList.find((s) => s.toLowerCase() === clean) || null;
  };

  // Ouvrir la modale d'ajout rapide d'un fournisseur
  const handleOpenAddSupplier = (initialName = "", target = "global") => {
    setAddingSupplierTarget(target);
    setNewSupplierForm({
      companyName: initialName,
      phone: "",
      address: "",
      MatriculeF: "",
      category: "Achats Quotidiens",
      notes: ""
    });
    setShowAddSupplierModal(true);
  };

  // Création & Enregistrement du fournisseur avec blocage strict des doublons
  const handleCreateSupplier = async () => {
    const trimmedName = newSupplierForm.companyName.trim();
    if (!trimmedName) {
      alert("Veuillez renseigner le nom ou la raison sociale du fournisseur.");
      return;
    }

    const existingMatch = findExistingSupplier(trimmedName);
    if (existingMatch) {
      alert(
        `⚠️ Un fournisseur avec le nom "${existingMatch}" existe déjà dans la base de données !\n\nVeuillez utiliser le fournisseur existant afin d'éviter les doublons de comptes.`
      );
      return;
    }

    setSavingSupplier(true);
    try {
      const res = await axios.post("/api/suppliers/addSupplier", {
        ...newSupplierForm,
        companyName: trimmedName
      });

      const savedName = res.data?.supplier?.companyName || trimmedName;

      // Actualiser la liste locale
      setSuppliersList((prev) => {
        const next = [...prev, savedName];
        return Array.from(new Set(next)).sort();
      });

      // Appliquer au champ concerné
      if (addingSupplierTarget === "global") {
        setSupplierGlobalName(savedName);
      } else if (addingSupplierTarget === "article-new") {
        setNewArticleForm((prev) => ({ ...prev, supplierName: savedName }));
      } else if (typeof addingSupplierTarget === "number") {
        handleItemFieldChange(addingSupplierTarget, "supplierName", savedName);
      }

      setShowAddSupplierModal(false);
      setSupplierNotification({
        message: `✅ Fournisseur "${savedName}" créé et enregistré avec succès dans l'application !`,
        type: "success"
      });
      setTimeout(() => setSupplierNotification(null), 5000);
    } catch (err) {
      console.error("Erreur création fournisseur:", err);
      const errMsg =
        err.response?.data?.error ||
        err.response?.data?.message ||
        "Erreur lors de l'enregistrement du fournisseur.";
      alert(`Erreur : ${errMsg}`);
    } finally {
      setSavingSupplier(false);
    }
  };

  // Chargement des données
  const fetchRequests = async () => {
    setLoading(true);
    try {
      let locList = [];
      try {
        const locRes = await axios.get("/api/Locations/getAllLocations");
        locList = Array.isArray(locRes.data) ? locRes.data : locRes.data.locations || [];
      } catch (e) {
        const locRes2 = await axios.get("/api/Locations");
        locList = Array.isArray(locRes2.data) ? locRes2.data : locRes2.data.locations || [];
      }
      setLocations(locList);

      const reqRes = await axios.get("/api/daily-purchases/requests");
      setRequests(reqRes.data || []);

      // Chargement des familles/catégories
      try {
        const catRes = await axios.get("/api/daily-purchases/categories");
        if (catRes.data && Array.isArray(catRes.data) && catRes.data.length > 0) {
          setCategoriesList(catRes.data);
        }
      } catch (errCat) {
        console.warn("Notice chargement catégories:", errCat);
      }

      // Chargement de la liste des fournisseurs enregistrés dans l'application
      try {
        const [supRes1, supRes2] = await Promise.allSettled([
          axios.get("/api/suppliers/getSuppliers"),
          axios.get("/api/SuppliersV/getSuppliers")
        ]);
        const names = new Set();
        if (supRes1.status === "fulfilled" && supRes1.value?.data) {
          const list = supRes1.value.data.suppliers || supRes1.value.data || [];
          list.forEach((s) => s.companyName && names.add(s.companyName.trim()));
        }
        if (supRes2.status === "fulfilled" && supRes2.value?.data) {
          const list = supRes2.value.data.suppliers || supRes2.value.data || [];
          list.forEach((s) => s.companyName && names.add(s.companyName.trim()));
        }
        setSuppliersList(Array.from(names).sort());
      } catch (errSup) {
        console.warn("Notice chargement fournisseurs:", errSup);
      }
    } catch (err) {
      console.error("Erreur chargement demandes pour contrôleur:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  // Ouverture du modal de validation
  const handleOpenProcessModal = (req) => {
    setActiveRequest(req);
    setShowAddArticleForm(false);
    setSelectedPresetCat("");

    // Initialise les articles avec les quantités achetées par défaut égales aux quantités demandées si non renseignées
    const initItems = (req.items || []).map((it) => ({
      ...it,
      requestedQuantity: it.requestedQuantity !== undefined && it.requestedQuantity !== null ? Number(it.requestedQuantity) : 1,
      purchasedQuantity: it.purchasedQuantity > 0 ? Number(it.purchasedQuantity) : (Number(it.requestedQuantity) || 1),
      actualUnitPrice: it.actualUnitPrice > 0 ? Number(it.actualUnitPrice) : (Number(it.estimatedUnitPrice) || 0),
      actualTotalPrice:
        it.actualTotalPrice > 0
          ? Number(it.actualTotalPrice)
          : (it.purchasedQuantity > 0 ? Number(it.purchasedQuantity) : (Number(it.requestedQuantity) || 1)) *
            (it.actualUnitPrice > 0 ? Number(it.actualUnitPrice) : (Number(it.estimatedUnitPrice) || 0)),
      supplierName: it.supplierName || req.supplierGlobalName || "",
      itemStatus: it.itemStatus || "achete"
    }));

    setEditedItems(initItems);
    setControllerNotes(req.controllerNotes || "");
    setInvoiceNumber(req.invoiceNumber || "");
    setSupplierGlobalName(req.supplierGlobalName || "");
    setPaymentMethod(req.paymentMethod || "Espece");
  };

  // Mise à jour inline des champs d'un article dans la modale
  const handleItemFieldChange = (index, field, value) => {
    setEditedItems((prev) => {
      const updated = [...prev];
      const item = { ...updated[index], [field]: value };

      if (field === "purchasedQuantity" || field === "actualUnitPrice") {
        const q = parseFloat(field === "purchasedQuantity" ? value : item.purchasedQuantity) || 0;
        const p = parseFloat(field === "actualUnitPrice" ? value : item.actualUnitPrice) || 0;
        item.actualTotalPrice = Math.round(q * p * 1000) / 1000;
      } else if (field === "actualTotalPrice") {
        const tot = parseFloat(value) || 0;
        const q = parseFloat(item.purchasedQuantity) || 1;
        item.actualUnitPrice = q > 0 ? Math.round((tot / q) * 1000) / 1000 : 0;
      } else if (field === "requestedQuantity") {
        item.requestedQuantity = parseFloat(value) || 0;
      }

      updated[index] = item;
      return updated;
    });
  };

  // Suppression d'un article du tableau par le contrôleur
  const handleRemoveItem = (index) => {
    const itemToRemove = editedItems[index];
    const name = itemToRemove?.articleName || `l'article #${index + 1}`;
    if (window.confirm(`Êtes-vous sûr de vouloir supprimer "${name}" de cette commande ?`)) {
      setEditedItems((prev) => prev.filter((_, i) => i !== index));
      setSupplierNotification({
        message: `🗑️ Article "${name}" supprimé de la liste.`,
        type: "warning"
      });
      setTimeout(() => setSupplierNotification(null), 3000);
    }
  };

  // Basculer l'affichage du formulaire d'ajout d'article
  const handleToggleAddForm = () => {
    setShowAddArticleForm((prev) => {
      const next = !prev;
      if (next) {
        const initialCat = categoriesList[0]?.name || "Fournitures de bureau";
        setSelectedPresetCat(initialCat);
        setNewArticleForm({
          categoryName: initialCat,
          subCategoryName: "",
          articleName: "",
          unit: "pièce",
          requestedQuantity: 1,
          purchasedQuantity: 1,
          actualUnitPrice: 0,
          actualTotalPrice: 0,
          supplierName: supplierGlobalName || "",
          notes: ""
        });
      }
      return next;
    });
  };

  // Sélection rapide d'une famille prédéfinie pour l'ajout
  const handleSelectPresetCategory = (catName) => {
    setSelectedPresetCat(catName);
    const cat = categoriesList.find((c) => c.name === catName);
    setNewArticleForm((prev) => ({
      ...prev,
      categoryName: catName,
      subCategoryName: "",
      articleName: "",
      unit: cat?.subCategories?.[0]?.unit || "pièce",
      actualUnitPrice: cat?.subCategories?.[0]?.estimatedPrice || 0,
      actualTotalPrice: Math.round((cat?.subCategories?.[0]?.estimatedPrice || 0) * (Number(prev.purchasedQuantity) || 1) * 1000) / 1000
    }));
  };

  // Sélection d'un sous-article prédéfini
  const handleSelectPresetSubArticle = (sub) => {
    if (!sub) return;
    const price = Number(sub.estimatedPrice) || 0;
    const qty = Number(newArticleForm.purchasedQuantity) || 1;
    setNewArticleForm((prev) => ({
      ...prev,
      articleName: sub.name,
      subCategoryName: sub.name,
      unit: sub.unit || "pièce",
      actualUnitPrice: price,
      actualTotalPrice: Math.round(price * qty * 1000) / 1000
    }));
  };

  // Mise à jour des champs du formulaire d'ajout
  const handleNewArticleFieldChange = (field, value) => {
    setNewArticleForm((prev) => {
      const updated = { ...prev, [field]: value };
      if (field === "purchasedQuantity" || field === "actualUnitPrice") {
        const q = parseFloat(field === "purchasedQuantity" ? value : updated.purchasedQuantity) || 0;
        const p = parseFloat(field === "actualUnitPrice" ? value : updated.actualUnitPrice) || 0;
        updated.actualTotalPrice = Math.round(q * p * 1000) / 1000;
      } else if (field === "actualTotalPrice") {
        const tot = parseFloat(value) || 0;
        const q = parseFloat(updated.purchasedQuantity) || 1;
        updated.actualUnitPrice = q > 0 ? Math.round((tot / q) * 1000) / 1000 : 0;
      }
      return updated;
    });
  };

  // Enregistrement & Ajout effectif de l'article dans la liste
  const handleAddNewArticleSubmit = (e) => {
    if (e) e.preventDefault();
    const trimmedName = newArticleForm.articleName.trim();
    if (!trimmedName) {
      alert("Veuillez renseigner le nom ou la désignation de l'article.");
      return;
    }

    const purQty = parseFloat(newArticleForm.purchasedQuantity) || 1;
    const reqQty = parseFloat(newArticleForm.requestedQuantity) || purQty;
    const unitP = parseFloat(newArticleForm.actualUnitPrice) || 0;
    const totP = parseFloat(newArticleForm.actualTotalPrice) || Math.round(purQty * unitP * 1000) / 1000;

    const itemToAdd = {
      categoryName: newArticleForm.categoryName.trim() || "Général",
      subCategoryName: newArticleForm.subCategoryName.trim() || trimmedName,
      articleName: trimmedName,
      unit: newArticleForm.unit.trim() || "pièce",
      requestedQuantity: reqQty,
      estimatedUnitPrice: unitP,
      estimatedTotalPrice: Math.round(reqQty * unitP * 1000) / 1000,
      purchasedQuantity: purQty,
      actualUnitPrice: unitP,
      actualTotalPrice: totP,
      supplierName: newArticleForm.supplierName.trim() || supplierGlobalName || "",
      notes: newArticleForm.notes.trim(),
      itemStatus: "achete",
      isAddedByController: true
    };

    setEditedItems((prev) => [...prev, itemToAdd]);
    setShowAddArticleForm(false);
    setSupplierNotification({
      message: `✅ Article "${trimmedName}" ajouté à la commande avec succès !`,
      type: "success"
    });
    setTimeout(() => setSupplierNotification(null), 4000);
  };

  // Ajout direct d'une ligne vierge rapide dans le tableau
  const handleQuickAddEmptyRow = () => {
    const newItem = {
      categoryName: "Général",
      subCategoryName: "Nouvel article",
      articleName: "Nouvel article",
      unit: "pièce",
      requestedQuantity: 1,
      estimatedUnitPrice: 0,
      estimatedTotalPrice: 0,
      purchasedQuantity: 1,
      actualUnitPrice: 0,
      actualTotalPrice: 0,
      supplierName: supplierGlobalName || "",
      notes: "",
      itemStatus: "achete",
      isAddedByController: true
    };
    setEditedItems((prev) => [...prev, newItem]);
    setSupplierNotification({
      message: "➕ Ligne vierge ajoutée. Vous pouvez modifier son nom, quantité et prix directement.",
      type: "success"
    });
    setTimeout(() => setSupplierNotification(null), 3500);
  };

  // Sauvegarde & Validation par le Contrôleur
  const handleSaveValidation = async (newStatus = "valide_controleur") => {
    if (!activeRequest) return;

    if (newStatus === "valide_controleur") {
      if (editedItems.length === 0) {
        alert("⚠️ Vous ne pouvez pas valider un bon d'achat sans aucun article. Veuillez ajouter au moins un article ou rejeter la demande.");
        return;
      }
      const hasEmptyName = editedItems.some((it) => !it.articleName || !String(it.articleName).trim());
      if (hasEmptyName) {
        alert("⚠️ Tous les articles doivent comporter une désignation ou un nom valide.");
        return;
      }
    }

    setValidating(true);
    try {
      const payload = {
        controllerName: currentUser?.name || "Contrôleur",
        controllerNotes,
        invoiceNumber,
        supplierGlobalName,
        paymentMethod,
        items: editedItems,
        status: newStatus
      };

      await axios.put(`/api/daily-purchases/requests/${activeRequest._id}/validate-purchase`, payload);
      setActiveRequest(null);
      fetchRequests();
    } catch (err) {
      console.error("Erreur validation achat contrôleur:", err);
      alert(err.response?.data?.error || "Erreur lors de la validation de l'achat.");
    } finally {
      setValidating(false);
    }
  };

  // Impression officielle du bon de demande d'achat & contrôle
  const handlePrintRequest = (reqToPrint, customItems = null) => {
    if (!reqToPrint) return;
    const items = customItems || reqToPrint.items || [];
    const dateFormatted =
      reqToPrint.createdAt || reqToPrint.requestDate
        ? new Date(reqToPrint.createdAt || reqToPrint.requestDate).toLocaleDateString("fr-FR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
          })
        : new Date().toLocaleDateString("fr-FR");

    const totalAmount = (
      Number(reqToPrint.totalActualAmount) ||
      items.reduce(
        (s, it) =>
          s +
          (Number(it.actualTotalPrice) ||
            Number(it.estimatedTotalPrice) ||
            (Number(it.purchasedQuantity || it.requestedQuantity) *
              Number(it.actualUnitPrice || it.estimatedUnitPrice)) ||
            0),
        0
      )
    ).toFixed(3);

    const isValidated = reqToPrint.status === "valide_controleur";

    const rowsHtml = items
      .map(
        (it, idx) => `
        <tr>
          <td style="text-align:center; padding: 7px 8px; border: 1px solid #cbd5e1; font-weight: bold;">${idx + 1}</td>
          <td style="padding: 7px 8px; border: 1px solid #cbd5e1;">
            <div style="font-weight: bold; color: #0f172a;">${it.articleName || "-"}</div>
            ${it.notes ? `<div style="font-size: 11px; color: #0284c7; font-style: italic;">Note: ${it.notes}</div>` : ""}
          </td>
          <td style="padding: 7px 8px; border: 1px solid #cbd5e1; font-size: 12px; color: #475569;">${it.categoryName || "-"} (${it.unit || "pièce"})</td>
          <td style="text-align:center; padding: 7px 8px; border: 1px solid #cbd5e1; font-weight: bold;">${it.requestedQuantity || 0} ${it.unit || ""}</td>
          <td style="text-align:center; padding: 7px 8px; border: 1px solid #cbd5e1; font-weight: bold; color: ${isValidated ? "#15803d" : "#475569"};">
            ${isValidated ? (it.purchasedQuantity > 0 ? `${it.purchasedQuantity} ${it.unit || ""}` : (it.requestedQuantity || 0)) : (it.requestedQuantity || 0)}
          </td>
          <td style="text-align:right; padding: 7px 8px; border: 1px solid #cbd5e1;">
            ${(isValidated ? (Number(it.actualUnitPrice) || Number(it.estimatedUnitPrice) || 0) : (Number(it.estimatedUnitPrice) || Number(it.actualUnitPrice) || 0)).toFixed(3)}
          </td>
          <td style="text-align:right; padding: 7px 8px; border: 1px solid #cbd5e1; font-weight: bold; color: ${isValidated ? "#0f172a" : "#b45309"};">
            ${(isValidated 
              ? (Number(it.actualTotalPrice) || (Number(it.purchasedQuantity || it.requestedQuantity) * Number(it.actualUnitPrice || it.estimatedUnitPrice)) || 0)
              : (Number(it.estimatedTotalPrice) || (Number(it.requestedQuantity) * Number(it.estimatedUnitPrice || it.actualUnitPrice)) || 0)
            ).toFixed(3)} DT
          </td>
          <td style="padding: 7px 8px; border: 1px solid #cbd5e1; font-size: 12px;">${it.supplierName || reqToPrint.supplierGlobalName || "-"}</td>
        </tr>
      `
      )
      .join("");

    const statusLabel = isValidated
      ? "VALIDÉ & FACTURÉ (RÉEL)"
      : reqToPrint.status === "en_cours_achat"
      ? "EN COURS D'ACHAT (INDICATIF)"
      : reqToPrint.status === "rejete"
      ? "REJETÉ"
      : "EN ATTENTE CONTRÔLE (INDICATIF)";

    const printHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8" />
          <title>Demande d'Achat - ${reqToPrint.reference} ${isValidated ? "(RÉEL)" : "(INDICATIF)"}</title>
          <style>
            @page { size: A4; margin: 15mm; }
            body { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: #0f172a; margin: 0; padding: 15px; font-size: 13px; line-height: 1.4; }
            .header { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #0f172a; padding-bottom: 12px; margin-bottom: 16px; }
            .logo { font-size: 22px; font-weight: 900; color: #0f172a; letter-spacing: 0.5px; }
            .logo span { color: #2563eb; }
            .title { font-size: 16px; font-weight: 800; text-transform: uppercase; color: ${isValidated ? "#1e293b" : "#b45309"}; margin-top: 4px; }
            .meta-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; margin-bottom: 18px; }
            .meta-card { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 12px 14px; }
            .meta-row { display: flex; justify-content: space-between; margin-bottom: 6px; font-size: 12.5px; }
            .meta-label { color: #64748b; font-weight: 600; }
            .meta-val { color: #0f172a; font-weight: 800; }
            table { width: 100%; border-collapse: collapse; margin-bottom: 18px; font-size: 12px; }
            th { background: #0f172a; color: white; padding: 8px 10px; font-weight: 700; border: 1px solid #0f172a; font-size: 11.5px; }
            .total-banner { background: ${isValidated ? "#0f172a" : "#334155"}; color: white; border-radius: 8px; padding: 12px 18px; display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
            .total-banner .amount { font-size: 20px; font-weight: 900; color: ${isValidated ? "#4ade80" : "#fbbf24"}; }
            .notes-box { background: #f1f5f9; border-left: 4px solid #0284c7; padding: 10px 14px; border-radius: 4px; margin-bottom: 20px; font-size: 12px; }
            .signatures { display: grid; grid-template-columns: 1fr 1fr; gap: 30px; margin-top: 30px; }
            .sign-box { border: 1.5px dashed #94a3b8; border-radius: 8px; height: 100px; padding: 10px; position: relative; }
            .sign-title { font-weight: 800; font-size: 12px; color: #334155; text-transform: uppercase; }
            .footer-info { text-align: center; margin-top: 30px; font-size: 10.5px; color: #94a3b8; border-top: 1px solid #e2e8f0; padding-top: 10px; }
          </style>
        </head>
        <body>
          <div class="header">
            <div>
              <div class="logo">TASKO<span>POS</span></div>
              <div class="title">
                ${isValidated ? "🛒 Bon de Commande & Contrôle d'Achat (RÉEL)" : "📝 Demande d'Achat (À TITRE INDICATIF)"}
              </div>
            </div>
            <div style="text-align: right;">
              <div style="font-size: 15px; font-weight: 900; color: #0f172a;">Réf: ${reqToPrint.reference}</div>
              <div style="font-size: 12px; color: #64748b;">Émis le : ${dateFormatted}</div>
              <div style="display: inline-block; margin-top: 4px; padding: 3px 10px; background: ${isValidated ? "#dcfce7" : "#fef3c7"}; color: ${isValidated ? "#15803d" : "#b45309"}; border-radius: 12px; font-size: 11px; font-weight: 800;">
                STATUT : ${statusLabel}
              </div>
            </div>
          </div>

          ${
            isValidated
              ? `
            <div style="background: #f0fdf4; border: 1.5px solid #bbf7d0; border-left: 6px solid #16a34a; padding: 10px 14px; border-radius: 6px; margin-bottom: 16px; font-size: 12px; color: #166534;">
              <strong>✅ BON OFFICIEL VALIDÉ & CONFIRMÉ PAR LE CONTRÔLEUR :</strong>
              <div style="margin-top: 2px;">Cette demande a été validée avec les montants réels facturés. Les prix et totaux ci-dessous sont <u>DÉFINITIFS ET RÉELS</u>.</div>
            </div>
          `
              : `
            <div style="background: #fffbeb; border: 1.5px solid #fde68a; border-left: 6px solid #f59e0b; padding: 10px 14px; border-radius: 6px; margin-bottom: 16px; font-size: 12px; color: #92400e;">
              <strong>⚠️ DOCUMENT PROVISOIRE — PRIX & MONTANTS À TITRE INDICATIF :</strong>
              <div style="margin-top: 2px;">Cette demande n'a pas encore été validée par le Contrôleur. Tous les prix unitaires et montants totaux ci-dessous sont <u>À TITRE PUREMENT ESTIMATIF / INDICATIF</u> et seront ajustés lors de la validation finale.</div>
            </div>
          `
          }

          <div class="meta-grid">
            <div class="meta-card">
              <div class="meta-row">
                <span class="meta-label">📍 Emplacement :</span>
                <span class="meta-val">${reqToPrint.locationName || "-"}</span>
              </div>
              <div class="meta-row">
                <span class="meta-label">👤 Demandeur :</span>
                <span class="meta-val">${reqToPrint.requestedByName || "Commercial"}</span>
              </div>
              <div class="meta-row" style="margin: 0;">
                <span class="meta-label">🚚 Fournisseur Global :</span>
                <span class="meta-val">${reqToPrint.supplierGlobalName || "Multiple / Par article"}</span>
              </div>
            </div>

            <div class="meta-card">
              <div class="meta-row">
                <span class="meta-label">🔍 Contrôleur :</span>
                <span class="meta-val">${reqToPrint.controllerName || currentUser?.name || (isValidated ? "Service Contrôle" : "En attente")}</span>
              </div>
              <div class="meta-row">
                <span class="meta-label">📄 N° Facture / Reçu :</span>
                <span class="meta-val">${reqToPrint.invoiceNumber || invoiceNumber || (isValidated ? "-" : "En attente")}</span>
              </div>
              <div class="meta-row" style="margin: 0;">
                <span class="meta-label">💳 Mode de Paiement :</span>
                <span class="meta-val">${reqToPrint.paymentMethod || paymentMethod || "Espèces"}</span>
              </div>
            </div>
          </div>

          <table>
            <thead>
              <tr>
                <th style="width: 30px; text-align:center;">#</th>
                <th style="text-align:left;">Désignation Article</th>
                <th style="text-align:left;">Famille / Unité</th>
                <th style="text-align:center;">Qté Demandée</th>
                <th style="text-align:center;">${isValidated ? "Qté Réelle" : "Qté Estimée"}</th>
                <th style="text-align:right;">${isValidated ? "P.U Réel (DT)" : "P.U Indicatif (DT)"}</th>
                <th style="text-align:right;">${isValidated ? "Total Réel (DT)" : "Total Indicatif (DT)"}</th>
                <th style="text-align:left;">Fournisseur</th>
              </tr>
            </thead>
            <tbody>
              ${rowsHtml}
            </tbody>
          </table>

          <div class="total-banner">
            <div>
              <span style="font-size: 13px; font-weight: 700; color: #cbd5e1;">Total Articles : </span>
              <span style="font-size: 14px; font-weight: 800;">${items.length} article(s)</span>
            </div>
            <div style="text-align: right;">
              <span style="font-size: 13px; font-weight: 800; margin-right: 10px;">
                ${isValidated ? "MONTANT TOTAL RÉEL VALIDÉ :" : "MONTANT ESTIMÉ TOTAL (À TITRE INDICATIF) :"}
              </span>
              <span class="amount">${totalAmount} DT</span>
              ${!isValidated ? `<div style="font-size: 11px; color: #fde68a; font-weight: 600; margin-top: 2px;">* Montant indicatif sous réserve de facturation définitive</div>` : ""}
            </div>
          </div>

          ${
            (reqToPrint.generalNotes || reqToPrint.controllerNotes || controllerNotes)
              ? `
            <div class="notes-box">
              ${reqToPrint.generalNotes ? `<div><strong>📝 Justification demandeur :</strong> ${reqToPrint.generalNotes}</div>` : ""}
              ${(reqToPrint.controllerNotes || controllerNotes) ? `<div style="margin-top: 4px; color: #0f172a;"><strong>🔍 Observations du Contrôleur :</strong> ${reqToPrint.controllerNotes || controllerNotes}</div>` : ""}
            </div>
          `
              : ""
          }

          <div class="signatures">
            <div class="sign-box">
              <div class="sign-title">Demandeur / Commercial Emplacement</div>
              <div style="font-size: 11px; color: #64748b; margin-top: 4px;">Signature & Date :</div>
            </div>
            <div class="sign-box">
              <div class="sign-title">Visa & Cachet Contrôleur des Achats</div>
              <div style="font-size: 11px; color: #64748b; margin-top: 4px;">${isValidated ? "Validé & Conforme :" : "Visa pour contrôle :"}</div>
            </div>
          </div>

          <div class="footer-info">
            Document généré automatiquement par TASKO POS le ${new Date().toLocaleDateString("fr-FR")} à ${new Date().toLocaleTimeString("fr-FR")} — ${isValidated ? "CONFIRMATION OFFICIELLE" : "VALEUR INDICATIVE"}
          </div>

          <script>
            window.onload = function() {
              window.print();
            };
          </script>
        </body>
      </html>
    `;

    const printWindow = window.open("", "_blank", "width=850,height=900");
    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(printHtml);
      printWindow.document.close();
    }
  };

  // Suppression d'une demande
  const handleDelete = async (id) => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer cette demande d'achat ?")) return;
    try {
      await axios.delete(`/api/daily-purchases/requests/${id}`);
      fetchRequests();
    } catch (err) {
      console.error("Erreur suppression:", err);
    }
  };

  // Filtrage des demandes
  const filteredRequests = requests.filter((r) => {
    const matchStatus =
      selectedStatus === "all"
        ? true
        : selectedStatus === "en_attente"
        ? r.status === "en_attente" || !r.status
        : r.status === selectedStatus;
    const matchLocation = selectedLocation === "all" || r.locationName === selectedLocation;
    const matchSearch =
      !search.trim() ||
      r.reference?.toLowerCase().includes(search.toLowerCase()) ||
      r.locationName?.toLowerCase().includes(search.toLowerCase()) ||
      r.requestedByName?.toLowerCase().includes(search.toLowerCase()) ||
      r.items?.some((it) => it.articleName.toLowerCase().includes(search.toLowerCase()));
    return matchStatus && matchLocation && matchSearch;
  });

  // Compteurs par statut
  const countPending = requests.filter((r) => r.status === "en_attente" || !r.status).length;
  const countInProgress = requests.filter((r) => r.status === "en_cours_achat").length;
  const countValidated = requests.filter((r) => r.status === "valide_controleur").length;
  const countRejected = requests.filter((r) => r.status === "rejete").length;

  // Totaux modale
  const modalTotalRequestedQty = editedItems.reduce((s, it) => s + (Number(it.requestedQuantity) || 0), 0);
  const modalTotalPurchasedQty = editedItems.reduce((s, it) => s + (Number(it.purchasedQuantity) || 0), 0);
  const modalTotalActualCost = editedItems.reduce((s, it) => s + (Number(it.actualTotalPrice) || 0), 0);

  return (
    <div className="dp-card">
      <div className="dp-card-header">
        <div>
          <h3 className="dp-card-title">
            📋 Espace Contrôle & Validation des Achats Quotidiens
          </h3>
          <p style={{ margin: "4px 0 0", color: "#64748b", fontSize: "0.88rem" }}>
            Vérifiez les demandes en attente faites par chaque emplacement, saisissez les quantités/prix réels, et validez (les demandes traitées passent automatiquement en historique).
          </p>
        </div>

        {/* Barre de filtres */}
        <div className="dp-filters-bar">
          <select
            className="dp-filter-select"
            value={selectedLocation}
            onChange={(e) => setSelectedLocation(e.target.value)}
          >
            <option value="all">Tous les emplacements</option>
            {locations.map((loc, idx) => {
              const locName = typeof loc === "string" ? loc : (loc.name || loc.localisation || loc._id);
              const key = (typeof loc === "object" && loc._id) ? loc._id : `${locName}_${idx}`;
              return (
                <option key={key} value={locName}>
                  🏪 {locName}
                </option>
              );
            })}
          </select>

          <input
            type="text"
            className="dp-filter-input"
            placeholder="🔍 Réf, article, demandeur..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <button className="dp-btn dp-btn-secondary" onClick={fetchRequests} title="Actualiser">
            🔄 Actualiser
          </button>
        </div>
      </div>

      {/* Onglets rapides de statut pour le contrôleur (Alignés sur une seule ligne) */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          padding: "10px 18px",
          background: "#f8fafc",
          borderBottom: "1.5px solid #e2e8f0",
          flexWrap: "nowrap",
          overflowX: "auto",
          alignItems: "center",
          scrollbarWidth: "none"
        }}
      >
        <span
          style={{
            fontSize: "0.85rem",
            fontWeight: "800",
            color: "#334155",
            whiteSpace: "nowrap",
            marginRight: "4px",
            display: "flex",
            alignItems: "center",
            gap: "6px"
          }}
        >
          <span>🎯</span>
          <span>Affichage :</span>
        </span>

        <button
          type="button"
          onClick={() => setSelectedStatus("en_attente")}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "6px 14px",
            borderRadius: "20px",
            fontSize: "0.82rem",
            fontWeight: "800",
            whiteSpace: "nowrap",
            flexShrink: 0,
            border: "1.5px solid",
            borderColor: selectedStatus === "en_attente" ? "#d97706" : "#cbd5e1",
            background: selectedStatus === "en_attente" ? "#fef3c7" : "#ffffff",
            color: selectedStatus === "en_attente" ? "#92400e" : "#475569",
            cursor: "pointer",
            boxShadow:
              selectedStatus === "en_attente"
                ? "0 2px 8px rgba(217, 119, 6, 0.25)"
                : "none",
            transition: "all 0.15s ease"
          }}
        >
          <span>⏳ À Traiter / En Attente</span>
          <span
            style={{
              background: selectedStatus === "en_attente" ? "#d97706" : "#e2e8f0",
              color: selectedStatus === "en_attente" ? "#ffffff" : "#475569",
              padding: "1px 7px",
              borderRadius: "10px",
              fontSize: "0.75rem",
              fontWeight: "900"
            }}
          >
            {countPending}
          </span>
        </button>

        <button
          type="button"
          onClick={() => setSelectedStatus("en_cours_achat")}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "6px 14px",
            borderRadius: "20px",
            fontSize: "0.82rem",
            fontWeight: "800",
            whiteSpace: "nowrap",
            flexShrink: 0,
            border: "1.5px solid",
            borderColor: selectedStatus === "en_cours_achat" ? "#2563eb" : "#cbd5e1",
            background: selectedStatus === "en_cours_achat" ? "#eff6ff" : "#ffffff",
            color: selectedStatus === "en_cours_achat" ? "#1d4ed8" : "#475569",
            cursor: "pointer",
            boxShadow:
              selectedStatus === "en_cours_achat"
                ? "0 2px 8px rgba(37, 99, 235, 0.25)"
                : "none",
            transition: "all 0.15s ease"
          }}
        >
          <span>🛒 En Cours d'Achat</span>
          <span
            style={{
              background: selectedStatus === "en_cours_achat" ? "#2563eb" : "#e2e8f0",
              color: selectedStatus === "en_cours_achat" ? "#ffffff" : "#475569",
              padding: "1px 7px",
              borderRadius: "10px",
              fontSize: "0.75rem",
              fontWeight: "900"
            }}
          >
            {countInProgress}
          </span>
        </button>

        <button
          type="button"
          onClick={() => setSelectedStatus("valide_controleur")}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "6px 14px",
            borderRadius: "20px",
            fontSize: "0.82rem",
            fontWeight: "800",
            whiteSpace: "nowrap",
            flexShrink: 0,
            border: "1.5px solid",
            borderColor:
              selectedStatus === "valide_controleur" ? "#16a34a" : "#cbd5e1",
            background:
              selectedStatus === "valide_controleur" ? "#f0fdf4" : "#ffffff",
            color: selectedStatus === "valide_controleur" ? "#15803d" : "#475569",
            cursor: "pointer",
            boxShadow:
              selectedStatus === "valide_controleur"
                ? "0 2px 8px rgba(22, 163, 74, 0.25)"
                : "none",
            transition: "all 0.15s ease"
          }}
        >
          <span>✅ Validées & Facturées</span>
          <span
            style={{
              background:
                selectedStatus === "valide_controleur" ? "#16a34a" : "#e2e8f0",
              color:
                selectedStatus === "valide_controleur" ? "#ffffff" : "#475569",
              padding: "1px 7px",
              borderRadius: "10px",
              fontSize: "0.75rem",
              fontWeight: "900"
            }}
          >
            {countValidated}
          </span>
        </button>

        <button
          type="button"
          onClick={() => setSelectedStatus("rejete")}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "6px 14px",
            borderRadius: "20px",
            fontSize: "0.82rem",
            fontWeight: "800",
            whiteSpace: "nowrap",
            flexShrink: 0,
            border: "1.5px solid",
            borderColor: selectedStatus === "rejete" ? "#dc2626" : "#cbd5e1",
            background: selectedStatus === "rejete" ? "#fee2e2" : "#ffffff",
            color: selectedStatus === "rejete" ? "#b91c1c" : "#475569",
            cursor: "pointer",
            boxShadow:
              selectedStatus === "rejete"
                ? "0 2px 8px rgba(220, 38, 38, 0.25)"
                : "none",
            transition: "all 0.15s ease"
          }}
        >
          <span>❌ Rejetées</span>
          <span
            style={{
              background: selectedStatus === "rejete" ? "#dc2626" : "#e2e8f0",
              color: selectedStatus === "rejete" ? "#ffffff" : "#475569",
              padding: "1px 7px",
              borderRadius: "10px",
              fontSize: "0.75rem",
              fontWeight: "900"
            }}
          >
            {countRejected}
          </span>
        </button>

        <button
          type="button"
          onClick={() => setSelectedStatus("all")}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "6px 14px",
            borderRadius: "20px",
            fontSize: "0.82rem",
            fontWeight: "800",
            whiteSpace: "nowrap",
            flexShrink: 0,
            border: "1.5px solid",
            borderColor: selectedStatus === "all" ? "#0f172a" : "#cbd5e1",
            background: selectedStatus === "all" ? "#0f172a" : "#ffffff",
            color: selectedStatus === "all" ? "#ffffff" : "#475569",
            cursor: "pointer",
            boxShadow:
              selectedStatus === "all"
                ? "0 2px 8px rgba(15, 23, 42, 0.25)"
                : "none",
            transition: "all 0.15s ease"
          }}
        >
          <span>📑 Toutes</span>
          <span
            style={{
              background: selectedStatus === "all" ? "#334155" : "#e2e8f0",
              color: selectedStatus === "all" ? "#ffffff" : "#475569",
              padding: "1px 7px",
              borderRadius: "10px",
              fontSize: "0.75rem",
              fontWeight: "900"
            }}
          >
            {requests.length}
          </span>
        </button>
      </div>

      {/* Tableau des demandes */}
      {loading ? (
        <div style={{ textAlign: "center", padding: "40px", color: "#64748b" }}>
          <div className="spinner-border text-primary" role="status"></div>
          <p className="mt-2 font-weight-bold">Chargement des demandes...</p>
        </div>
      ) : filteredRequests.length === 0 ? (
        <div style={{ textAlign: "center", padding: "40px", color: "#94a3b8" }}>
          <span style={{ fontSize: "3rem" }}>📂</span>
          <h5>Aucune demande d'achat trouvée</h5>
          <p>Aucune demande ne correspond à vos filtres actuels.</p>
        </div>
      ) : (
        <div className="dp-table-container">
          <table className="dp-table">
            <thead>
              <tr>
                <th>Référence</th>
                <th>Date & Demandeur</th>
                <th>Emplacement</th>
                <th>Articles Demandés</th>
                <th>Montant Estimé</th>
                <th>Montant Réel Acheté</th>
                <th>Statut</th>
                <th style={{ textAlign: "right" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredRequests.map((req) => {
                let badgeClass = "dp-badge-pending";
                let badgeLabel = "En attente";
                if (req.status === "valide_controleur") {
                  badgeClass = "dp-badge-validated";
                  badgeLabel = "Validé";
                } else if (req.status === "en_cours_achat") {
                  badgeClass = "dp-badge-progress";
                  badgeLabel = "En cours";
                } else if (req.status === "rejete") {
                  badgeClass = "dp-badge-rejected";
                  badgeLabel = "Rejeté";
                }

                return (
                  <tr key={req._id}>
                    <td>
                      <span style={{ fontWeight: "800", color: "#0f172a" }}>
                        {req.reference}
                      </span>
                      {req.priority === "tres_urgent" && (
                        <span className="dp-badge dp-badge-rejected ms-1">
                          🔥 Urgent
                        </span>
                      )}
                    </td>

                    <td>
                      <div style={{ fontWeight: "700" }}>{req.requestedByName}</div>
                      <div style={{ fontSize: "0.75rem", color: "#64748b" }}>
                        {new Date(req.requestDate || req.createdAt).toLocaleDateString("fr-FR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit"
                        })}
                      </div>
                    </td>

                    <td>
                      <span
                        style={{
                          fontWeight: "800",
                          padding: "4px 8px",
                          borderRadius: "6px",
                          background: "#f1f5f9",
                          color: "#1e293b"
                        }}
                      >
                        📍 {req.locationName}
                      </span>
                    </td>

                    <td>
                      <span style={{ fontWeight: "700" }}>
                        {req.items?.length || 0} article(s)
                      </span>
                      <div
                        style={{
                          fontSize: "0.75rem",
                          color: "#64748b",
                          maxWidth: "200px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis"
                        }}
                      >
                        {req.items?.map((it) => it.articleName).join(", ")}
                      </div>
                    </td>

                    <td>
                      <span style={{ fontWeight: "700", color: "#64748b" }}>
                        {(req.totalEstimatedAmount || 0).toFixed(3)} DT
                      </span>
                    </td>

                    <td>
                      <span
                        style={{
                          fontWeight: "900",
                          color: req.totalActualAmount > 0 ? "#15803d" : "#94a3b8"
                        }}
                      >
                        {req.totalActualAmount > 0
                          ? `${req.totalActualAmount.toFixed(3)} DT`
                          : "Non chiffré"}
                      </span>
                    </td>

                    <td>
                      <span className={`dp-badge ${badgeClass}`}>{badgeLabel}</span>
                    </td>

                    <td style={{ textAlign: "right" }}>
                      <div style={{ display: "inline-flex", gap: "6px", alignItems: "center" }}>
                        <button
                          className="dp-btn dp-btn-primary"
                          style={{ padding: "6px 12px", fontSize: "0.82rem" }}
                          onClick={() => handleOpenProcessModal(req)}
                        >
                          {req.status === "valide_controleur" ? "👁️ Consulter / Modifier" : "⚡ Traiter & Valider"}
                        </button>

                        <button
                          className="dp-btn dp-btn-secondary"
                          style={{ padding: "6px 10px", fontSize: "0.82rem", fontWeight: "750" }}
                          onClick={() => handlePrintRequest(req)}
                          title="Imprimer le bon de demande & contrôle d'achat"
                        >
                          🖨️ Imprimer
                        </button>

                        <button
                          className="dp-btn dp-btn-secondary"
                          style={{ padding: "6px 10px", fontSize: "0.82rem" }}
                          onClick={() => handleDelete(req._id)}
                          title="Supprimer"
                        >
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* ── MODALE TRAITEMENT & CONTRÔLE COMPARATIF ── */}
      <Modal
        show={!!activeRequest}
        onHide={() => setActiveRequest(null)}
        size="xl"
        className="dp-custom-modal-root"
        dialogClassName="dp-fullscreen-modal-dialog"
        centered
      >
        <Modal.Header closeButton style={{ background: "#0f172a", color: "white" }}>
          <Modal.Title style={{ fontWeight: "800", fontSize: "1.2rem", color: "#ffffff" }}>
            🛒 Contrôle de l'Achat : {activeRequest?.reference} — Emplacement : {activeRequest?.locationName}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "16px 22px" }}>
          {/* Notification d'action fournisseur */}
          {supplierNotification && (
            <div
              className={`alert ${
                supplierNotification.type === "success"
                  ? "alert-success"
                  : "alert-warning"
              } py-2 px-3 mb-3 d-flex align-items-center justify-content-between`}
              style={{ borderRadius: "8px", fontWeight: "700", fontSize: "0.88rem" }}
            >
              <span>{supplierNotification.message}</span>
              <button
                type="button"
                className="btn-close btn-close-white ms-2"
                style={{ fontSize: "0.75rem" }}
                onClick={() => setSupplierNotification(null)}
              />
            </div>
          )}

          {/* Informations Générales & Fournisseur de l'achat */}
          <div
            style={{
              background: "#f8fafc",
              borderRadius: "10px",
              padding: "10px 16px",
              marginBottom: "12px",
              border: "1px solid #e2e8f0"
            }}
          >
            <div className="row g-2 align-items-start">
              <div className="col-md-5">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "4px" }}>
                  <label className="form-label font-weight-bold" style={{ fontSize: "0.82rem", margin: 0 }}>
                    🚚 Fournisseur Global
                  </label>
                  <div style={{ display: "flex", gap: "6px" }}>
                    <button
                      type="button"
                      style={{
                        background: "#f0fdf4",
                        border: "1px solid #86efac",
                        color: "#15803d",
                        fontSize: "0.72rem",
                        fontWeight: "800",
                        padding: "2px 8px",
                        borderRadius: "6px",
                        cursor: "pointer"
                      }}
                      onClick={() => handleOpenAddSupplier(supplierGlobalName, "global")}
                      title="Créer et enregistrer un nouveau fournisseur dans l'application"
                    >
                      ➕ Nouveau Fournisseur
                    </button>
                    {supplierGlobalName && (
                      <button
                        type="button"
                        style={{
                          background: "#eff6ff",
                          border: "1px solid #bfdbfe",
                          color: "#1d4ed8",
                          fontSize: "0.72rem",
                          fontWeight: "700",
                          padding: "2px 8px",
                          borderRadius: "6px",
                          cursor: "pointer"
                        }}
                        onClick={() => {
                          setEditedItems((prev) =>
                            prev.map((item) => ({ ...item, supplierName: supplierGlobalName }))
                          );
                        }}
                        title="Copier ce fournisseur sur toutes les lignes d'articles"
                      >
                        🏢 Appliquer à tous
                      </button>
                    )}
                  </div>
                </div>
                <input
                  type="text"
                  list="dp-registered-suppliers"
                  className="form-control"
                  style={{ padding: "7px 12px", fontSize: "0.88rem", fontWeight: "700" }}
                  placeholder="Sélectionner ou saisir un fournisseur..."
                  value={supplierGlobalName}
                  onChange={(e) => setSupplierGlobalName(e.target.value)}
                />
                <datalist id="dp-registered-suppliers">
                  {suppliersList.map((sup, sIdx) => (
                    <option key={sIdx} value={sup}>
                      {sup}
                    </option>
                  ))}
                </datalist>

                {/* Statut de vérification du fournisseur sous l'input */}
                {supplierGlobalName.trim() && (
                  <div style={{ marginTop: "4px", fontSize: "0.75rem" }}>
                    {findExistingSupplier(supplierGlobalName) ? (
                      <span style={{ color: "#166534", fontWeight: "700" }}>
                        ✅ Fournisseur enregistré dans l'application
                      </span>
                    ) : (
                      <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                        <span style={{ color: "#d97706", fontWeight: "700" }}>
                          ℹ️ Fournisseur non répertorié
                        </span>
                        <button
                          type="button"
                          style={{
                            background: "#fef3c7",
                            border: "1px solid #fde68a",
                            color: "#92400e",
                            fontWeight: "800",
                            fontSize: "0.7rem",
                            borderRadius: "4px",
                            padding: "1px 6px",
                            cursor: "pointer"
                          }}
                          onClick={() => handleOpenAddSupplier(supplierGlobalName, "global")}
                        >
                          ➕ L'enregistrer dans la base
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="col-md-2">
                <label className="form-label font-weight-bold" style={{ fontSize: "0.82rem", marginBottom: "4px" }}>
                  📄 N° Facture / Reçu
                </label>
                <input
                  type="text"
                  className="form-control"
                  style={{ padding: "7px 12px", fontSize: "0.88rem" }}
                  placeholder="Ex: FACT-2026-990"
                  value={invoiceNumber}
                  onChange={(e) => setInvoiceNumber(e.target.value)}
                />
              </div>

              <div className="col-md-2">
                <label className="form-label font-weight-bold" style={{ fontSize: "0.82rem", marginBottom: "4px" }}>
                  💳 Règlement
                </label>
                <select
                  className="form-control"
                  style={{ padding: "7px 12px", fontSize: "0.88rem" }}
                  value={paymentMethod}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                >
                  <option value="Espece">💵 Espèces (Caisse)</option>
                  <option value="Cheque">📑 Chèque</option>
                  <option value="Virement">🏦 Virement</option>
                  <option value="Carte">💳 Carte Bancaire</option>
                  <option value="Bon_Achat">🎟️ Bon d'achat</option>
                </select>
              </div>

              <div className="col-md-3">
                <label className="form-label font-weight-bold" style={{ fontSize: "0.82rem", marginBottom: "4px" }}>
                  👤 Demandeur
                </label>
                <div style={{ fontWeight: "700", paddingTop: "4px", color: "#334155", fontSize: "0.88rem" }}>
                  {activeRequest?.requestedByName} ({activeRequest?.locationName})
                </div>
              </div>
            </div>
          </div>

          {/* En-tête de section Tableau & Boutons d'ajout de produits */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
              flexWrap: "wrap",
              gap: "10px"
            }}
          >
            <div>
              <h5 style={{ fontWeight: "800", color: "#0f172a", margin: 0, fontSize: "1.05rem" }}>
                ⚖️ Articles de la Commande & Contrôle Réalisé ({editedItems.length} article{editedItems.length > 1 ? "s" : ""})
              </h5>
              <p style={{ margin: "2px 0 0", color: "#64748b", fontSize: "0.78rem" }}>
                Vous pouvez modifier les désignations, quantités et prix, ajouter de nouveaux produits ou supprimer des articles non retenus.
              </p>
            </div>

            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                style={{
                  fontWeight: "800",
                  fontSize: "0.82rem",
                  padding: "5px 12px",
                  borderRadius: "8px",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  boxShadow: "0 2px 6px rgba(37, 99, 235, 0.25)"
                }}
                onClick={handleToggleAddForm}
              >
                <span>{showAddArticleForm ? "✖️ Fermer le formulaire" : "➕ Ajouter un produit / article"}</span>
              </button>

              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                style={{
                  fontWeight: "750",
                  fontSize: "0.82rem",
                  padding: "5px 12px",
                  borderRadius: "8px",
                  background: "#ffffff",
                  borderColor: "#cbd5e1",
                  color: "#334155"
                }}
                onClick={handleQuickAddEmptyRow}
                title="Insérer directement une nouvelle ligne vide dans le tableau"
              >
                ⚡ Ligne vide rapide
              </button>
            </div>
          </div>

          {/* Formulaire rétractable d'Ajout d'Article */}
          {showAddArticleForm && (
            <div
              style={{
                background: "linear-gradient(135deg, #f0fdf4 0%, #f8fafc 100%)",
                border: "1.5px solid #86efac",
                borderRadius: "12px",
                padding: "16px 18px",
                marginBottom: "16px",
                boxShadow: "0 4px 12px rgba(22, 163, 74, 0.08)"
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px", borderBottom: "1px solid #bbf7d0", paddingBottom: "8px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span style={{ fontSize: "1.1rem" }}>📦</span>
                  <span style={{ fontWeight: "800", color: "#166534", fontSize: "0.95rem" }}>
                    Nouveau Produit à Ajouter à la Demande
                  </span>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "0.75rem" }}
                  onClick={() => setShowAddArticleForm(false)}
                />
              </div>

              {/* Sélection rapide par catalogue de familles */}
              <div style={{ marginBottom: "12px" }}>
                <label style={{ fontSize: "0.78rem", fontWeight: "750", color: "#334155", display: "block", marginBottom: "6px" }}>
                  🎯 Sélection rapide depuis les familles existantes (Optionnel) :
                </label>
                <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "8px" }}>
                  {categoriesList.map((cat, cIdx) => (
                    <button
                      key={cIdx}
                      type="button"
                      style={{
                        padding: "3px 10px",
                        borderRadius: "16px",
                        fontSize: "0.75rem",
                        fontWeight: "750",
                        border: selectedPresetCat === cat.name ? "1.5px solid #16a34a" : "1px solid #cbd5e1",
                        background: selectedPresetCat === cat.name ? "#dcfce7" : "#ffffff",
                        color: selectedPresetCat === cat.name ? "#15803d" : "#475569",
                        cursor: "pointer"
                      }}
                      onClick={() => handleSelectPresetCategory(cat.name)}
                    >
                      {cat.icon || "📦"} {cat.name}
                    </button>
                  ))}
                </div>

                {/* Sous-articles de la famille sélectionnée */}
                {selectedPresetCat && (
                  <div style={{ background: "#ffffff", padding: "8px 12px", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
                    <div style={{ fontSize: "0.72rem", color: "#64748b", fontWeight: "700", marginBottom: "4px" }}>
                      👉 Cliquez sur un article standard pour préremplir :
                    </div>
                    <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                      {(categoriesList.find((c) => c.name === selectedPresetCat)?.subCategories || []).map((sub, sIdx) => (
                        <button
                          key={sIdx}
                          type="button"
                          style={{
                            padding: "3px 8px",
                            borderRadius: "6px",
                            fontSize: "0.74rem",
                            fontWeight: "600",
                            border: newArticleForm.articleName === sub.name ? "1.5px solid #2563eb" : "1px dashed #94a3b8",
                            background: newArticleForm.articleName === sub.name ? "#eff6ff" : "#f8fafc",
                            color: newArticleForm.articleName === sub.name ? "#1d4ed8" : "#334155",
                            cursor: "pointer"
                          }}
                          onClick={() => handleSelectPresetSubArticle(sub)}
                        >
                          {sub.name} <span style={{ color: "#16a34a", fontWeight: "750" }}>({(sub.estimatedPrice || 0).toFixed(3)} DT)</span>
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Formulaire de saisie détaillée */}
              <div className="row g-2 align-items-end">
                <div className="col-md-4">
                  <label className="form-label font-weight-bold" style={{ fontSize: "0.78rem", marginBottom: "3px" }}>
                    Désignation Article *
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    style={{ fontWeight: "750", fontSize: "0.85rem" }}
                    placeholder="Ex: Rouleau caisse, Café 1kg, Javel..."
                    value={newArticleForm.articleName}
                    onChange={(e) => handleNewArticleFieldChange("articleName", e.target.value)}
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label font-weight-bold" style={{ fontSize: "0.78rem", marginBottom: "3px" }}>
                    Famille / Catégorie
                  </label>
                  <input
                    type="text"
                    list="dp-categories-list-options"
                    className="form-control form-control-sm"
                    style={{ fontSize: "0.82rem" }}
                    placeholder="Famille..."
                    value={newArticleForm.categoryName}
                    onChange={(e) => handleNewArticleFieldChange("categoryName", e.target.value)}
                  />
                  <datalist id="dp-categories-list-options">
                    {categoriesList.map((c, idx) => (
                      <option key={idx} value={c.name} />
                    ))}
                  </datalist>
                </div>

                <div className="col-md-2">
                  <label className="form-label font-weight-bold" style={{ fontSize: "0.78rem", marginBottom: "3px" }}>
                    Unité
                  </label>
                  <select
                    className="form-control form-control-sm"
                    style={{ fontSize: "0.82rem" }}
                    value={newArticleForm.unit}
                    onChange={(e) => handleNewArticleFieldChange("unit", e.target.value)}
                  >
                    {STANDARD_UNITS.map((u, idx) => (
                      <option key={idx} value={u}>
                        {u}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2">
                  <label className="form-label font-weight-bold" style={{ fontSize: "0.78rem", marginBottom: "3px" }}>
                    Qté Achetée Réelle *
                  </label>
                  <input
                    type="number"
                    min="0"
                    step="any"
                    className="form-control form-control-sm"
                    style={{ fontWeight: "800", fontSize: "0.85rem", color: "#166534" }}
                    value={newArticleForm.purchasedQuantity}
                    onChange={(e) => handleNewArticleFieldChange("purchasedQuantity", e.target.value)}
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label font-weight-bold" style={{ fontSize: "0.78rem", marginBottom: "3px" }}>
                    Prix Unitaire Réel (DT)
                  </label>
                  <input
                    type="number"
                    min="0"
                    step="0.001"
                    className="form-control form-control-sm"
                    style={{ fontSize: "0.85rem", fontWeight: "750" }}
                    value={newArticleForm.actualUnitPrice}
                    onChange={(e) => handleNewArticleFieldChange("actualUnitPrice", e.target.value)}
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label font-weight-bold" style={{ fontSize: "0.78rem", marginBottom: "3px" }}>
                    Montant Total Réel (DT)
                  </label>
                  <input
                    type="number"
                    min="0"
                    step="0.001"
                    className="form-control form-control-sm"
                    style={{ fontWeight: "900", color: "#15803d", fontSize: "0.88rem" }}
                    value={newArticleForm.actualTotalPrice}
                    onChange={(e) => handleNewArticleFieldChange("actualTotalPrice", e.target.value)}
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label font-weight-bold" style={{ fontSize: "0.78rem", marginBottom: "3px" }}>
                    Fournisseur Ligne
                  </label>
                  <div style={{ display: "flex", gap: "4px" }}>
                    <input
                      type="text"
                      list="dp-registered-suppliers"
                      className="form-control form-control-sm"
                      style={{ fontSize: "0.82rem" }}
                      placeholder="Fournisseur pour cet article..."
                      value={newArticleForm.supplierName}
                      onChange={(e) => handleNewArticleFieldChange("supplierName", e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-success"
                      style={{ fontSize: "0.72rem", padding: "2px 8px", whiteSpace: "nowrap", fontWeight: "800" }}
                      onClick={() => handleOpenAddSupplier(newArticleForm.supplierName, "article-new")}
                      title="Créer un nouveau fournisseur"
                    >
                      ➕
                    </button>
                  </div>
                </div>

                <div className="col-md-4">
                  <label className="form-label font-weight-bold" style={{ fontSize: "0.78rem", marginBottom: "3px" }}>
                    Note / Observation contrôleur
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    style={{ fontSize: "0.82rem" }}
                    placeholder="Raison d'ajout, marque, référence..."
                    value={newArticleForm.notes}
                    onChange={(e) => handleNewArticleFieldChange("notes", e.target.value)}
                  />
                </div>

                <div className="col-md-2" style={{ display: "flex", gap: "6px" }}>
                  <button
                    type="button"
                    className="btn btn-sm btn-success w-100"
                    style={{ fontWeight: "800", fontSize: "0.82rem", padding: "6px 10px" }}
                    onClick={handleAddNewArticleSubmit}
                  >
                    💾 Insérer l'Article
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Tableau Comparatif & Éditable des Articles */}
          <div className="dp-table-container mb-2" style={{ maxHeight: "460px", overflowY: "auto" }}>
            <table className="dp-table" style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead style={{ background: "#0f172a", color: "white", position: "sticky", top: 0, zIndex: 10 }}>
                <tr>
                  <th style={{ width: "35px", textAlign: "center", color: "#cbd5e1" }}>#</th>
                  <th style={{ minWidth: "200px" }}>Désignation & Famille (Modifiables)</th>
                  <th style={{ width: "100px", textAlign: "center" }}>Unité</th>
                  <th style={{ width: "95px", textAlign: "center" }}>Qté Demandée</th>
                  <th style={{ width: "110px", textAlign: "center", color: "#86efac" }}>Qté Achetée</th>
                  <th style={{ width: "95px", textAlign: "center" }}>Écart</th>
                  <th style={{ width: "115px", textAlign: "right" }}>P.U Réel (DT)</th>
                  <th style={{ width: "125px", textAlign: "right", color: "#86efac" }}>Total Réel (DT)</th>
                  <th style={{ minWidth: "160px" }}>Fournisseur & Note</th>
                  <th style={{ width: "50px", textAlign: "center" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {editedItems.length === 0 ? (
                  <tr>
                    <td colSpan="10" style={{ textAlign: "center", padding: "26px 16px", color: "#64748b" }}>
                      <div style={{ fontSize: "1.5rem", marginBottom: "6px" }}>🛒</div>
                      <div style={{ fontWeight: "750", color: "#334155" }}>Aucun article dans cette commande</div>
                      <div style={{ fontSize: "0.82rem", marginTop: "4px" }}>
                        Utilisez le bouton <strong>« ➕ Ajouter un produit / article »</strong> ci-dessus pour ajouter des lignes.
                      </div>
                    </td>
                  </tr>
                ) : (
                  editedItems.map((item, idx) => {
                    const reqQty = Number(item.requestedQuantity) || 0;
                    const purQty = Number(item.purchasedQuantity) || 0;
                    const diffQty = purQty - reqQty;
                    const isKnownSupplier = !item.supplierName || findExistingSupplier(item.supplierName);

                    return (
                      <tr
                        key={idx}
                        style={{
                          background: item.isAddedByController ? "#f0fdf4" : (idx % 2 === 0 ? "#ffffff" : "#f8fafc")
                        }}
                      >
                        {/* Numéro de ligne */}
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          <span
                            style={{
                              fontWeight: "800",
                              fontSize: "0.78rem",
                              color: item.isAddedByController ? "#15803d" : "#64748b"
                            }}
                          >
                            {idx + 1}
                          </span>
                        </td>

                        {/* Désignation & Famille modifiables */}
                        <td style={{ verticalAlign: "top" }}>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            style={{
                              fontWeight: "800",
                              fontSize: "0.86rem",
                              color: "#0f172a",
                              padding: "4px 8px",
                              marginBottom: "3px",
                              borderColor: item.isAddedByController ? "#86efac" : "#cbd5e1"
                            }}
                            placeholder="Nom de l'article..."
                            value={item.articleName || ""}
                            onChange={(e) => handleItemFieldChange(idx, "articleName", e.target.value)}
                          />

                          <div style={{ display: "flex", gap: "6px", alignItems: "center", flexWrap: "wrap" }}>
                            <input
                              type="text"
                              list="dp-categories-list-options"
                              className="form-control form-control-sm"
                              style={{
                                fontSize: "0.72rem",
                                padding: "2px 6px",
                                width: "130px",
                                color: "#475569"
                              }}
                              placeholder="Famille..."
                              value={item.categoryName || ""}
                              onChange={(e) => handleItemFieldChange(idx, "categoryName", e.target.value)}
                            />

                            {item.isAddedByController && (
                              <span
                                style={{
                                  fontSize: "0.68rem",
                                  fontWeight: "800",
                                  color: "#15803d",
                                  background: "#dcfce7",
                                  padding: "2px 6px",
                                  borderRadius: "4px"
                                }}
                              >
                                ➕ Ajouté contrôleur
                              </span>
                            )}
                          </div>
                        </td>

                        {/* Unité modifiable */}
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          <select
                            className="form-control form-control-sm"
                            style={{ fontSize: "0.78rem", padding: "4px 4px", textAlign: "center" }}
                            value={item.unit || "pièce"}
                            onChange={(e) => handleItemFieldChange(idx, "unit", e.target.value)}
                          >
                            {STANDARD_UNITS.map((u, uIdx) => (
                              <option key={uIdx} value={u}>
                                {u}
                              </option>
                            ))}
                          </select>
                        </td>

                        {/* Quantité demandée (Modifiable) */}
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          <input
                            type="number"
                            min="0"
                            step="any"
                            className="dp-ctrl-input"
                            style={{
                              width: "75px",
                              fontWeight: "750",
                              fontSize: "0.84rem",
                              textAlign: "center",
                              background: "#f1f5f9",
                              border: "1px solid #cbd5e1"
                            }}
                            value={item.requestedQuantity}
                            onChange={(e) => handleItemFieldChange(idx, "requestedQuantity", e.target.value)}
                            title="Quantité demandée initialement"
                          />
                        </td>

                        {/* Quantité achetée réelle (Modifiable) */}
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          <input
                            type="number"
                            min="0"
                            step="any"
                            className="dp-ctrl-input dp-ctrl-input-qty"
                            style={{
                              width: "80px",
                              fontWeight: "900",
                              fontSize: "0.9rem",
                              textAlign: "center",
                              color: "#15803d",
                              border: "1.5px solid #86efac",
                              background: "#f0fdf4"
                            }}
                            value={item.purchasedQuantity}
                            onChange={(e) => handleItemFieldChange(idx, "purchasedQuantity", e.target.value)}
                            title="Quantité réellement achetée"
                          />
                        </td>

                        {/* Écart de quantité */}
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          <span
                            style={{
                              fontSize: "0.78rem",
                              fontWeight: "800",
                              padding: "2px 6px",
                              borderRadius: "6px",
                              display: "inline-block",
                              background: diffQty === 0 ? "#f0fdf4" : diffQty < 0 ? "#fef2f2" : "#fef3c7",
                              color: diffQty === 0 ? "#166534" : diffQty < 0 ? "#dc2626" : "#d97706"
                            }}
                          >
                            {diffQty === 0 ? "0 (Conforme)" : diffQty > 0 ? `+${diffQty}` : `${diffQty}`}
                          </span>
                        </td>

                        {/* Prix unitaire réel (Modifiable) */}
                        <td style={{ textAlign: "right", verticalAlign: "middle" }}>
                          <input
                            type="number"
                            min="0"
                            step="0.001"
                            className="dp-ctrl-input dp-ctrl-input-price"
                            style={{ width: "95px", fontSize: "0.85rem", fontWeight: "750", textAlign: "right" }}
                            value={item.actualUnitPrice}
                            onChange={(e) => handleItemFieldChange(idx, "actualUnitPrice", e.target.value)}
                          />
                        </td>

                        {/* Montant total réel (Modifiable) */}
                        <td style={{ textAlign: "right", verticalAlign: "middle" }}>
                          <input
                            type="number"
                            min="0"
                            step="0.001"
                            className="dp-ctrl-input dp-ctrl-input-price"
                            style={{
                              width: "105px",
                              fontWeight: "900",
                              color: "#15803d",
                              fontSize: "0.9rem",
                              textAlign: "right",
                              background: "#f0fdf4",
                              border: "1.5px solid #bbf7d0"
                            }}
                            value={item.actualTotalPrice}
                            onChange={(e) => handleItemFieldChange(idx, "actualTotalPrice", e.target.value)}
                          />
                        </td>

                        {/* Fournisseur & Note modifiables */}
                        <td style={{ verticalAlign: "top" }}>
                          <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                            <div style={{ display: "flex", gap: "2px" }}>
                              <input
                                type="text"
                                list="dp-registered-suppliers"
                                className="form-control form-control-sm"
                                style={{ fontSize: "0.78rem", padding: "3px 6px" }}
                                placeholder="Fournisseur..."
                                value={item.supplierName || ""}
                                onChange={(e) => handleItemFieldChange(idx, "supplierName", e.target.value)}
                              />
                              {!isKnownSupplier && item.supplierName && item.supplierName.trim() && (
                                <button
                                  type="button"
                                  style={{
                                    background: "#fef3c7",
                                    border: "1px solid #fde68a",
                                    color: "#92400e",
                                    fontWeight: "800",
                                    fontSize: "0.65rem",
                                    borderRadius: "4px",
                                    padding: "0 4px",
                                    cursor: "pointer",
                                    whiteSpace: "nowrap"
                                  }}
                                  onClick={() => handleOpenAddSupplier(item.supplierName, idx)}
                                  title="Enregistrer ce fournisseur dans la base"
                                >
                                  ➕
                                </button>
                              )}
                            </div>

                            <input
                              type="text"
                              className="form-control form-control-sm"
                              style={{
                                fontSize: "0.72rem",
                                color: "#0369a1",
                                fontStyle: "italic",
                                padding: "2px 6px",
                                borderColor: "#e2e8f0"
                              }}
                              placeholder="Note / observation..."
                              value={item.notes || ""}
                              onChange={(e) => handleItemFieldChange(idx, "notes", e.target.value)}
                            />
                          </div>
                        </td>

                        {/* Bouton Suppression */}
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            style={{
                              padding: "4px 8px",
                              fontSize: "0.85rem",
                              borderRadius: "6px",
                              lineHeight: 1
                            }}
                            onClick={() => handleRemoveItem(idx)}
                            title="Supprimer cet article de la liste"
                          >
                            🗑️
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* Synthèse globale et remarques du contrôleur */}
          <div className="row g-3">
            <div className="col-md-7">
              <label className="form-label font-weight-bold">
                📝 Visa & Observations du Contrôleur
              </label>
              <textarea
                className="form-control"
                rows="3"
                placeholder="Ajoutez des précisions sur les prix obtenus, les éventuelles ruptures de stock ou les choix fournisseurs..."
                value={controllerNotes}
                onChange={(e) => setControllerNotes(e.target.value)}
              />
            </div>

            <div className="col-md-5">
              <div
                style={{
                  background: "#0f172a",
                  color: "white",
                  padding: "18px",
                  borderRadius: "12px",
                  boxShadow: "0 4px 14px rgba(15, 23, 42, 0.2)"
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                  <span>Total Articles Achetés :</span>
                  <span style={{ fontWeight: "800" }}>
                    {modalTotalPurchasedQty} / {modalTotalRequestedQty}
                  </span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                  <span>Mode de paiement :</span>
                  <span style={{ fontWeight: "700" }}>{paymentMethod}</span>
                </div>
                <hr style={{ borderColor: "#334155", margin: "10px 0" }} />
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontSize: "1.1rem", fontWeight: "800" }}>
                    MONTANT TOTAL RÉEL :
                  </span>
                  <span style={{ fontSize: "1.45rem", fontWeight: "900", color: "#4ade80" }}>
                    {modalTotalActualCost.toFixed(3)} DT
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer style={{ background: "#f8fafc", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px", padding: "16px 24px" }}>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <Button
              variant="outline-danger"
              style={{ fontWeight: "700", whiteSpace: "nowrap" }}
              onClick={() => handleSaveValidation("rejete")}
              disabled={validating}
            >
              ❌ Rejeter la demande
            </Button>
            <Button
              variant="outline-primary"
              style={{ fontWeight: "700", whiteSpace: "nowrap" }}
              onClick={() => handleSaveValidation("en_cours_achat")}
              disabled={validating}
            >
              🛒 Mettre en cours d'achat
            </Button>
          </div>

          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" }}>
            <Button
              variant="outline-secondary"
              style={{
                fontWeight: "800",
                whiteSpace: "nowrap",
                border: "1.5px solid #cbd5e1",
                background: "#ffffff",
                color: "#0f172a"
              }}
              onClick={() => handlePrintRequest(activeRequest, editedItems)}
              title="Imprimer le bon de demande et contrôle d'achat"
            >
              🖨️ Imprimer la Demande
            </Button>
            <Button
              variant="secondary"
              style={{ fontWeight: "700", whiteSpace: "nowrap" }}
              onClick={() => setActiveRequest(null)}
              disabled={validating}
            >
              Fermer
            </Button>
            <Button
              variant="success"
              style={{ fontWeight: "800", padding: "8px 22px", whiteSpace: "nowrap" }}
              onClick={() => handleSaveValidation("valide_controleur")}
              disabled={validating}
            >
              {validating ? "Validation en cours..." : "✅ Valider l'Achat & Générer la Facture"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* ── MODALE CRÉATION DIRECTE FOURNISSEUR AVEC CONTRÔLE ANTI-DOUBLON ── */}
      <Modal
        show={showAddSupplierModal}
        onHide={() => !savingSupplier && setShowAddSupplierModal(false)}
        size="md"
        centered
        style={{ zIndex: 1060 }}
      >
        <Modal.Header
          closeButton={!savingSupplier}
          style={{
            background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
            color: "white"
          }}
        >
          <Modal.Title
            style={{
              color: "#ffffff",
              fontWeight: "800",
              fontSize: "1.1rem",
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
          >
            <span>🏢</span>
            <span>Nouveau Fournisseur (Ajout Direct)</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "20px" }}>
          {/* Vérification instantanée de doublon */}
          {(() => {
            const matchName = findExistingSupplier(newSupplierForm.companyName);
            if (matchName) {
              return (
                <div
                  style={{
                    background: "#fef2f2",
                    border: "1.5px solid #fecaca",
                    borderRadius: "10px",
                    padding: "12px 14px",
                    marginBottom: "16px"
                  }}
                >
                  <div
                    style={{
                      color: "#991b1b",
                      fontWeight: "800",
                      fontSize: "0.88rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px"
                    }}
                  >
                    <span>⚠️ Doublon Détecté !</span>
                  </div>
                  <div
                    style={{
                      color: "#b91c1c",
                      fontSize: "0.82rem",
                      marginTop: "4px"
                    }}
                  >
                    Un fournisseur avec le nom{" "}
                    <strong>« {matchName} »</strong> est déjà enregistré dans
                    l'application. Pour garder une base propre et éviter les
                    doublons de comptes :
                  </div>
                  <button
                    type="button"
                    style={{
                      marginTop: "8px",
                      background: "#dc2626",
                      color: "white",
                      border: "none",
                      padding: "4px 12px",
                      borderRadius: "6px",
                      fontSize: "0.78rem",
                      fontWeight: "800",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      if (addingSupplierTarget === "global") {
                        setSupplierGlobalName(matchName);
                      } else if (typeof addingSupplierTarget === "number") {
                        handleItemFieldChange(
                          addingSupplierTarget,
                          "supplierName",
                          matchName
                        );
                      }
                      setShowAddSupplierModal(false);
                    }}
                  >
                    👉 Sélectionner « {matchName} » existant
                  </button>
                </div>
              );
            } else if (newSupplierForm.companyName.trim()) {
              return (
                <div
                  style={{
                    background: "#f0fdf4",
                    border: "1px solid #bbf7d0",
                    borderRadius: "8px",
                    padding: "8px 12px",
                    marginBottom: "14px",
                    color: "#166534",
                    fontSize: "0.8rem",
                    fontWeight: "700"
                  }}
                >
                  ✨ Nom disponible — Aucun doublon trouvé dans la base.
                </div>
              );
            }
            return null;
          })()}

          <div className="mb-3">
            <label
              className="form-label font-weight-bold"
              style={{ fontSize: "0.85rem" }}
            >
              Raison Sociale / Nom du Fournisseur *
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Ex: Société Quincaillerie Moderne, Grossiste Alimentaire..."
              value={newSupplierForm.companyName}
              onChange={(e) =>
                setNewSupplierForm({
                  ...newSupplierForm,
                  companyName: e.target.value
                })
              }
              autoFocus
            />
          </div>

          <div className="row g-2 mb-3">
            <div className="col-md-6">
              <label
                className="form-label font-weight-bold"
                style={{ fontSize: "0.82rem" }}
              >
                📞 Téléphone
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Ex: 71 000 000 / 98 000 000"
                value={newSupplierForm.phone}
                onChange={(e) =>
                  setNewSupplierForm({
                    ...newSupplierForm,
                    phone: e.target.value
                  })
                }
              />
            </div>
            <div className="col-md-6">
              <label
                className="form-label font-weight-bold"
                style={{ fontSize: "0.82rem" }}
              >
                📑 Matricule Fiscal (MF)
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Ex: 1234567/A/M/000"
                value={newSupplierForm.MatriculeF}
                onChange={(e) =>
                  setNewSupplierForm({
                    ...newSupplierForm,
                    MatriculeF: e.target.value
                  })
                }
              />
            </div>
          </div>

          <div className="mb-3">
            <label
              className="form-label font-weight-bold"
              style={{ fontSize: "0.82rem" }}
            >
              📍 Adresse / Ville
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Ex: Rue de l'Industrie, Tunis"
              value={newSupplierForm.address}
              onChange={(e) =>
                setNewSupplierForm({
                  ...newSupplierForm,
                  address: e.target.value
                })
              }
            />
          </div>

          <div className="mb-2">
            <label
              className="form-label font-weight-bold"
              style={{ fontSize: "0.82rem" }}
            >
              📝 Notes / Catégorie d'activité
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Ex: Grossiste Emballages & Papeterie"
              value={newSupplierForm.notes}
              onChange={(e) =>
                setNewSupplierForm({
                  ...newSupplierForm,
                  notes: e.target.value
                })
              }
            />
          </div>
        </Modal.Body>

        <Modal.Footer style={{ background: "#f8fafc", padding: "12px 20px" }}>
          <Button
            variant="secondary"
            onClick={() => setShowAddSupplierModal(false)}
            disabled={savingSupplier}
          >
            Annuler
          </Button>
          <Button
            variant="success"
            onClick={handleCreateSupplier}
            disabled={
              savingSupplier ||
              !newSupplierForm.companyName.trim() ||
              !!findExistingSupplier(newSupplierForm.companyName)
            }
            style={{ fontWeight: "800" }}
          >
            {savingSupplier
              ? "Enregistrement..."
              : "💾 Enregistrer & Utiliser"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ControleValidationAchats;
